import Cookies from "js-cookie";

import { getUuid } from "./index";

const TokenKey = "zhiti_pingtai_token";


export function getToken() {
  return Cookies.get(TokenKey);
}

export function setToken(token) {
  // const seconds = 8 * 3600
  // const expires = new Date(new Date()*1 + seconds * 1000)
  // return Cookies.set(TokenKey, token, { expires: expires })
  return Cookies.set(TokenKey, token);
}

export function removeToken() {
  return Cookies.remove(TokenKey);
}

export function createToken() {
  return getUuid();
}

/**
 * 设置 Cookies
 * @param {*} name
 * @param {*} value
 * @returns
 */
export function setCookies(name, value) {
  return Cookies.set(name, value);
}

/**
 * 获取 Cookies
 * @param {*} name
 * @param {*} value
 * @returns
 */
export function getCookies(name) {
  return Cookies.get(name);
}


/**
 * 移除 Cookies
 * @param {*} name
 * @returns
 */
export function removeCookies(name) {
  return Cookies.remove(name);
}
